import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Label, Optional, LabelWrapper } from './styles';
import { MoreInfo } from '../MoreInfo';
/**
 * Wrapper structure to add a label, info, help, and error context to form components
 */

export var Labeled = function Labeled(_ref) {
  var id = _ref.id,
      children = _ref.children,
      required = _ref.required,
      label = _ref.label,
      size = _ref.size,
      moreInfo = _ref.moreInfo,
      forId = _ref.forId,
      props = _objectWithoutProperties(_ref, ["id", "children", "required", "label", "size", "moreInfo", "forId"]);

  return /*#__PURE__*/React.createElement(LabelWrapper, Object.assign({
    size: size
  }, props), label && /*#__PURE__*/React.createElement(Label, {
    htmlFor: forId
  }, label, !required && /*#__PURE__*/React.createElement(Optional, null, "(optional)"), moreInfo && /*#__PURE__*/React.createElement(MoreInfo, {
    ml: 2,
    title: moreInfo,
    textAlignment: "center"
  })), children);
};